// NATIVE 
import * as React from 'react';


// INSTALLED 

import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { DetailCargo } from '../../cargos/detalle/DetailCargo';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





/**
 * DetailDialogCargo component renders a dialog with detailed information about a cargo.
 * 
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines whether the dialog is open or not.
 * @param {function} props.handleCloseModalDetailCargo - Function to handle closing the dialog.
 * @param {boolean} [props.buttons=false] - Optional flag to show buttons in the dialog.
 * 
 * @returns {JSX.Element} The rendered DetailDialogCargo component.
 */
export const DetailDialogCargo = (props:any) =>  {


  // PROPS 
  const{ open, handleCloseModalDetailCargo, buttons = false } = props;

  
  
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalDetailCargo(false);
  };

  
  

  return (
    <React.Fragment>


      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Detalle Cargo
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid>
            <DetailCargo/>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




